export default {
  "wt-input": "_wt-input_coltmm_1",
  "wt-input__wrapper": "_wt-input__wrapper_coltmm_5",
  "wt-input_theme_light": "_wt-input_theme_light_coltmm_14",
  "wt-input_theme_dark": "_wt-input_theme_dark_coltmm_24",
  "wt-input_disabled": "_wt-input_disabled_coltmm_34",
  "wt-input_error": "_wt-input_error_coltmm_46",
  "wt-input__field": "_wt-input__field_coltmm_53",
  "wt-input_size_l": "_wt-input_size_l_coltmm_68",
  "wt-input_size_m": "_wt-input_size_m_coltmm_74",
  "wt-input_size_s": "_wt-input_size_s_coltmm_80",
  "wt-input_size_xs": "_wt-input_size_xs_coltmm_86",
  "wt-input__inner": "_wt-input__inner_coltmm_92",
  "wt-input_off-system-microelements": "_wt-input_off-system-microelements_coltmm_271",
  "wt-input__icon": "_wt-input__icon_coltmm_282",
  "wt-input__icon_action": "_wt-input__icon_action_coltmm_288",
  "wt-input__icon_right": "_wt-input__icon_right_coltmm_292",
  "wt-input__icon_left": "_wt-input__icon_left_coltmm_308",
  "wt-input__suffix": "_wt-input__suffix_coltmm_348",
  "wt-input__error-message": "_wt-input__error-message_coltmm_411",
  "wt-input__note": "_wt-input__note_coltmm_417"
};